/**
 * Тонкий шар над токенами пакета: числа, яких бракує CSS, і назви класів.
 *
 * Самих значень тут немає. Вони живуть у `design.ts`, а той — копія
 * `design/tokens/tokens.ts` із пакета дизайн-системи
 * ([ADR-0039](../../../../docs/adr/0039-design-package.md)). Друге джерело
 * чисел тут означало б другу палітру, яка мовчки розійдеться з першою —
 * саме так досі розходилися канви й код.
 */
import tokens from "./design.js";
/** Кроки відступів пакета: `--space-1` … `--space-10`. Інших немає. */
export const SPACES = [1, 2, 3, 4, 5, 6, 8, 10];
export const space = (n) => `var(--space-${n})`;
/** Найменша ціль дотику. Число, бо його порівнюють тести й розмітка. */
export const TAP_MIN = Number.parseInt(tokens.size.tapMin, 10);
/** Найменший припустимий розмір тексту — `label`, 11. Нижче не буває. */
export const MIN_FONT_SIZE = 11;
/**
 * Клас типографіки з `tokens.css`: `bodyUi` → `body-ui`, `title1` → `title-1`.
 *
 * Класом, а не інлайном: у пакеті стиль тексту — це клас, і макети
 * вживають саме його. Інлайн дав би ті самі числа другим шляхом.
 */
export function textClass(name) {
    return name.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}
//# sourceMappingURL=scale.js.map